import React, { Children } from 'react';
import { SmartphoneIcon, CloudLightningIcon, TimerIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const problems = [{
    icon: SmartphoneIcon,
    title: 'Ruido Digital',
    description: 'Notificaciones sin fin, redes sociales que consumen tu atención y una mente que nunca descansa.'
  }, {
    icon: CloudLightningIcon,
    title: 'Ansiedad',
    description: 'Preocupación constante por el futuro, estrés laboral y una sensación de que algo siempre falta.'
  }, {
    icon: TimerIcon,
    title: 'Prisa Constante',
    description: 'Correr de una tarea a otra sin pausa, sin presencia, sin disfrutar realmente el momento.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="beneficios" className="py-24 bg-[#112240]" data-id="element-86">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-87">
        <div className="text-center mb-16" data-id="element-88">
          <span className="text-[#D4AF37] font-['Inter'] font-semibold tracking-[0.2em] text-sm mb-4 block uppercase" data-id="element-89">
            El Problema
          </span>
          <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#FFF8F0]" data-id="element-90">
            ¿Te identificas con esto?
          </h2>
        </div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-91">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-[#0A192F] border border-[#1D3461] rounded-2xl p-8 flex flex-col items-start hover:border-[#D4AF37]/30 transition-colors duration-300" data-id="element-92">
              <div className="w-14 h-14 rounded-full bg-[#1D3461]/50 flex items-center justify-center mb-6" data-id="element-93">
                <problem.icon className="w-7 h-7 text-[#D4AF37]" strokeWidth={1.5} data-id="element-94" />
              </div>
              <h3 className="text-2xl font-['Playfair_Display'] text-[#FFF8F0] mb-4" data-id="element-95">
                {problem.title}
              </h3>
              <p className="text-[#A8B2D1] font-['Inter'] leading-relaxed" data-id="element-96">
                {problem.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}